import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import * as Highcharts from 'highcharts';
import { DashboardService } from './dashboard.service';
import { FilterModel } from '../common-models/common.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  currentUser: any;
  mainMenu = [];
  labNotificationList : any
  dataModel = new FilterModel();
  customFilter = '';

//#region dailychart setup
  dailyChartBtnText = "Show Table";
  showDailyStatsTable = false;
  isDailyChartUpdated = false;
  dailyStatisticsList : any;
  dailyHighcharts = Highcharts;
  dailyChartOptions: Highcharts.Options = {
    chart: {
      type: 'column',
      renderTo: 'dailyChartId',
    },
    title: {
      text: 'Specimen Received'
    },
    series: [],
    xAxis: {
      categories: [],
      crosshair: true
    },
    yAxis: {
      min: 0,
      title: {
        text: 'number of cases'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
  };
//#endregion dailychart setup

//#region monthlychart setup
  monthlyChartBtnText = "Show Table";
  showMonthlyStatsTable = false
  monthlyStatisticsList : any;
  isMonthlyChartUpdated = false;
  montlyHighcharts = Highcharts;
  monthlyChartOptions: Highcharts.Options = {
    chart: {
      type: 'column',
    },
    title: {
      text: 'Specimen Received'
    },
    series: [],
    xAxis: {
      categories: [],
      crosshair: true
    },
    yAxis: {
      min: 0,
      title: {
        text: 'number of cases'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
  };
//#endregion monthlychart setup

  constructor( public sharedService: SharedService, public dashboardService: DashboardService) {

  }

  ngOnInit(): void {
    // this.currentUser = this.sharedService.currentUser;
    // this.mainMenu = this.sharedService.setMainMenu();
    this.getLabChartDailyData();
    this.getLabChartMonthData();
    this.getLabNotifications();
  }


  getLabChartDailyData() {
    this.dashboardService.getLabChartDailyData().subscribe(res => {
      if (res) {
        this.dailyStatisticsList = res;
       
        setTimeout(() => {
          this.dailyChartOptions.series = [
            { data: [res[0].numberOfPCRCases], name: 'PCR Cases', type: "column" },
            { data: [res[0].numberOfPGXCases], name: 'PGX Cases', type: "column" },
            { data: [res[0].numberOfOralCases], name: 'Oral Cases', type: "column" },
            { data: [res[0].numberOfUrineCases], name: 'Urine Cases', type: "column" },
            { data: [res[0].numberOfBloodCases], name: 'Blood Cases', type: "column" }
          ]
          this.dailyChartOptions.xAxis = {
            categories: [res[0].labName],
            crosshair: true
          },
          this.isDailyChartUpdated = true;
        }, 1000);
      }
    },err => { })
  }

  getLabChartMonthData() {
    this.dashboardService.getLabChartMonthData().subscribe(res => {
      if (res) {
        this.monthlyStatisticsList = res;

        setTimeout(() => {
          this.monthlyChartOptions.series = [
            { data: [res[0].numberOfPCRCases], name: 'PCR Cases', type: "column" },
            { data: [res[0].numberOfPGXCases], name: 'PGX Cases', type: "column" },
            { data: [res[0].numberOfOralCases], name: 'Oral Cases', type: "column" },
            { data: [res[0].numberOfUrineCases], name: 'Urine Cases', type: "column" },
            { data: [res[0].numberOfBloodCases], name: 'Blood Cases', type: "column" }
          ]
          this.monthlyChartOptions.xAxis = {
            categories: [res[0].labName],
            crosshair: true
          },
          this.isMonthlyChartUpdated = true;
        }, 1000);
      }
    },err => { })
  }
  
  getLabNotifications() {
    this.customFilter = 'Filter.IsAllNotification=' + false;
    this.dashboardService.getLabNotifications(this.dataModel, this.customFilter).subscribe(res => {
      if(res)
        this.labNotificationList = res.data;
    }, err => { })
  }

  showTable(statsType) {
    if (statsType == 'monthly'){
      this.showMonthlyStatsTable = !this.showMonthlyStatsTable;
      this.monthlyChartBtnText = this.monthlyChartBtnText == "Show Table" ? "Show Chart" : "Show Table";
    }
    if (statsType == 'daily'){
      this.showDailyStatsTable = !this.showDailyStatsTable;
      this.dailyChartBtnText = this.dailyChartBtnText == "Show Table" ? "Show Chart" : "Show Table";
    }
  }
}
